
import ApiConfig from "../config/Api.config";
import Data from "../data/Api.data";
import Request from "../interfaces/Request.interface";
import Response from "../interfaces/Response.interface";

const url: string = `${Data.URLS.urlApiSinergia}/sepomex`;

const getEstadosLista = async () => {
    const request: Request = {
        url: `${url}/estados`,
        method: "GET",
    }
    const response: Response = await ApiConfig.executeRequest(request);
    return response;

};

const getCiudadesLista = async (IdEstado: number) => {
    const request: Request = {
        url: `${url}/estados/${IdEstado}/ciudades`,
        method: "GET",
    }
    const response: Response = await ApiConfig.executeRequest(request);
    return response;

};

const getLocalidadLista = async (IdEstado: number, IdCiudad: number) => {
    const request: Request = {
        url: `${url}/estados/${IdEstado}/ciudades/${IdCiudad}/localidades`,
        method: "GET",
    }
    const response: Response = await ApiConfig.executeRequest(request);
    return response;

};

const getMediosAtencionLista = async () => {
    const request: Request = {
        url: `${url}/medios-atencion`,
        method: "GET",
    }
    const response: Response = await ApiConfig.executeRequest(request);
    return response;

};

const SEPOMEXService = {
    getEstadosLista,
    getMediosAtencionLista,
    getCiudadesLista,
    getLocalidadLista,
};

export default SEPOMEXService;